export function logo() {
  const logo = document.querySelector('.js-home-logo');
  
  let shapeStart = '';
  let shapeEnd = '';
  const timer = 150;

  if(logo) {
    const shape = logo.querySelectorAll('.js-logo-shape');
    const el0 = shape[0];
    const el1 = shape[1];
    const el2 = shape[2];
    const el3 = shape[3];
    const el4 = shape[4];
    if(shape) {
      shapeStart = () => {
        setTimeout(() => {
          el0.classList.remove('is-start', 'is-end');
          el0.classList.add('is-start');
        }, timer)

        setTimeout(() => {
          el1.classList.remove('is-start', 'is-end');
          el1.classList.add('is-start');
        }, timer*2)

        setTimeout(() => {
          el2.classList.remove('is-start', 'is-end');
          el2.classList.add('is-start');
        }, timer*3)

        setTimeout(() => {
          el3.classList.remove('is-start', 'is-end');
          el3.classList.add('is-start');
        }, timer*4)

        setTimeout(() => {
          el4.classList.remove('is-start', 'is-end');
          el4.classList.add('is-start');
        }, timer*5)
      }
      shapeEnd = () => {
        setTimeout(() => {
          el0.classList.add('is-end');
        }, timer)

        setTimeout(() => {
          el1.classList.add('is-end');
        }, timer*2)

        setTimeout(() => {
          el2.classList.add('is-end');
        }, timer*3)

        setTimeout(() => {
          el3.classList.add('is-end');
        }, timer*4)

        setTimeout(() => {
          el4.classList.add('is-end');
        }, timer*5)
      }
    }

    shapeStart();
    const logoAnim = () => {
      setInterval(() => {
        shapeEnd();
        setTimeout(() => {
          shapeStart();
        }, 2500);
      }, 9000);
    }

    logoAnim();
  }
}